document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      const styleId = 'bss-b2b-visible-style';
      if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
          [bss-b2b-variant-price], 
          [bss-b2b-product-price], 
          [bss-b2b-cart-item-key][bss-b2b-item-original-price], 
          [bss-b2b-cart-item-key][bss-b2b-final-line-price], 
          [bss-b2b-cart-item-key] [bss-b2b-item-original-price], 
          [bss-b2b-cart-item-key] [bss-b2b-final-line-price], 
          [bss-b2b-cart-total-price] {
            visibility: visible !important;
          }
        `;
        document.head.appendChild(style);
      }
    }, 2000);

    const hideElementsByClass = (parent, className) => {
        if (!parent) 
            return;
        
        parent.querySelectorAll(className).forEach(element => {
            element.style.display = "none";
        });
    };
    const handlePriceVisibility = () => {
        //parent has TD
        const priceTax = document.querySelector("[bss-b2b-main-product-form] [bss-b2b-product-id]");
        //parent no TD
        const priceTaxQB = document.querySelector("div.bss-b2b-qty-table-wrapper");
        if (! priceTax || ! priceTaxQB) 
            return;
        
        const hasNoVatClass = priceTax.querySelector(".bss-b2b-price-no-vat");
        const hasVatClass = priceTax.querySelector(".bss-b2b-price-has-vat");
        if (hasNoVatClass && hasVatClass) 
            return;
        
        if (! hasNoVatClass) 
            hideElementsByClass(priceTaxQB, ".bss-b2b-price-no-vat");
        
        if (! hasVatClass) 
            hideElementsByClass(priceTaxQB, ".bss-b2b-price-has-vat");
        
    };
    /* AE-fix augustus 2026 — deze observer draaide handlePriceVisibility() bij
       ELKE DOM-mutatie op de hele pagina. Eén keer de winkelwagen opnieuw
       opbouwen vervangt honderden knopen, dus die functie werd honderden keren
       achter elkaar uitgevoerd, elke keer met twee attribuut-selectors over het
       hele document. Op een telefoon is dat precies het moment waarop de
       winkelwagen "vastloopt": de hoofdthread staat vol.

       Nu samengevoegd tot één uitvoering per animatieframe. Functioneel
       identiek (de laatste stand telt), alleen niet meer honderden keren. */
    let priceFrame = null;
    const schedulePriceVisibility = () => {
        if (priceFrame !== null) return;
        priceFrame = requestAnimationFrame(() => {
            priceFrame = null;
            handlePriceVisibility();
        });
    };

    const observer = new MutationObserver(schedulePriceVisibility);
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    handlePriceVisibility();
});

setTimeout(() => {
    /* AE-fix: idem — hier werd bij elke mutatie de volledige lijst doorlopen.
       Nu maximaal één melding per animatieframe. */
    let quickViewFrame = null;
    const observer = new MutationObserver((MutationList) => {
        if (quickViewFrame !== null) return;
        let hit = false;
        for (let item of MutationList) {
            if (item.target.nodeType === 1 && item.target.classList.contains("dbtfy-quick-view__content")) {
                hit = true;
                break;
            }
        }
        if (!hit) return;
        quickViewFrame = requestAnimationFrame(() => {
            quickViewFrame = null;
            try {
                BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
            } catch (e) {}
        });
    })
    observer.observe(document.body, {
        childList: true,
        subtree: true
    })
}, 300)